module.exports = __webpack_public_path__ + "static/img/transform@2x.535e1213.png";